import { resolveIQSourceHref } from "@components/utils/iqSourceLink";

/**
 * Resolves display text for an IQ Side Panel message.
 * User rows are strings; AI rows may be a string or `{ answer | text | message }`.
 *
 * @param {string|object|null|undefined} content
 * @returns {string}
 */
/**
 * @param {unknown} content
 * @returns {Array<{ title?: string, url?: string, source?: string, page_id?: string, domain?: string }>}
 */
export function extractIQSidePanelSources(content) {
  if (content == null || typeof content !== "object") {
    return [];
  }
  const sources = content.sources;
  if (!Array.isArray(sources)) {
    return [];
  }
  return sources.filter(
    (item) =>
      item &&
      typeof item === "object" &&
      (resolveIQSourceHref(item) || item.title)
  );
}

export function extractIQSidePanelMessageText(content) {
  if (content == null) {
    return "";
  }
  if (typeof content === "string") {
    return content;
  }
  if (typeof content === "object") {
    const answer = content.answer ?? content.text ?? content.message ?? "";
    return typeof answer === "string" ? answer : String(answer);
  }
  return String(content);
}

/**
 * Stable v-for key for a chat message. Prefers `id`; falls back to type + text.
 *
 * @param {{ id?: string|number, type?: string, content?: unknown, timestamp?: unknown }} message
 * @returns {string}
 */
export function iqSidePanelMessageKey(message) {
  if (!message || typeof message !== "object") {
    return "iq-side-panel-msg";
  }
  if (message.id != null && message.id !== "") {
    return String(message.id);
  }
  const text = extractIQSidePanelMessageText(message.content);
  return `${message.type || "msg"}-${text}`;
}
